export default "<!--<ng-container *ngIf=\"!showModal\">-->\n  <app-form></app-form>\n<!--</ng-container>-->\n"